export default {
  closeModal: "بستن پنجره ورود",
  enterLearningWorld: "ورود به دنیای یادگیری",
  confirmMobile: "تأیید شماره موبایل",
  enterMobileDescription: "شماره موبایل خود را وارد کنید تا کد تأیید برایتان ارسال شود.",
  enterCodeDescription: "کد ارسال‌شده به",
  mobileLabel: "شماره موبایل",
  mobilePlaceholder: "0912 123 4567",
  sendingOtp: "در حال ارسال...",
  sendOtpBtn: "ارسال کد تأیید",
  verifyingOtp: "در حال بررسی...",
  verifyOtpBtn: "تأیید و ورود",
  editMobile: "ویرایش شماره",
  resendTimer: "ارسال مجدد تا",
  resendCode: "ارسال مجدد کد",
  secureInfo: "اطلاعات شما نزد ما محفوظ است."
};
